import React, { useEffect, useState } from "react";
import { Modal, Button, Form, InputGroup } from "@themesberg/react-bootstrap";
import { faPaperPlane, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import API from "../utils/api";

const NotesBox = ({ show, onClose, claimId, isAdmin }) => {
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");

  useEffect(() => {
    if (!show || !claimId) return;
    fetchNotes();
  }, [show, claimId]);

  const fetchNotes = async () => {
    try {
      const res = await API.get(`claims/${claimId}/notes`);
      setNotes(res.data);
    } catch (err) {
      console.error(err);
    }
  };
useEffect(() => {
  if (!show || !claimId) return;

  setNotes([]); // Clear notes before fetching new ones
  fetchNotes();
}, [show, claimId]);

  const addNote = async () => {
    if (!newNote.trim()) return;
    try {
      await API.post(`claims/${claimId}/notes`, { message: newNote });
      setNewNote("");
      fetchNotes();
    } catch (err) {
      console.error(err);
    }
  };

const deleteNote = async (noteId) => {
  try {
    await API.delete(`claims/${claimId}/delete-notes/${noteId}`);
    fetchNotes();
  } catch (err) {
    console.error(err);
  }
};


  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Notes</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
        {notes.length > 0 ? (
          notes.map((note) => (
            <div
              key={note._id}
              className="p-2 mb-2 border rounded bg-light d-flex justify-content-between align-items-start"
              style={{ wordBreak: "break-word" }}
            >
              <div>
                <p className="mb-1">{note.message}</p>
                <small className="text-muted">
                  {new Date(note.createdAt).toLocaleString()}
                </small>
              </div>
              {isAdmin && (
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => deleteNote(note._id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              )}
            </div>
          ))
        ) : (
          <p className="text-muted">No notes yet.</p>
        )}
      </Modal.Body>

      {isAdmin && (
        <Modal.Footer>
          <InputGroup>
            <Form.Control
              type="text"
              value={newNote}
              onChange={(e) => setNewNote(e.target.value)}
              placeholder="Type a note..."
            />
            <Button variant="primary" onClick={addNote}>
              <FontAwesomeIcon icon={faPaperPlane} />
            </Button>
          </InputGroup>
        </Modal.Footer>
      )}

      {!isAdmin && (
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default NotesBox;
